var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFalkonDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21.243,
    viewBox: "0 0 18 21.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security-secure-protection-16-svgrepo-com",
    transform: "translate(-14.832 -11.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M31.581,25.581H24.79a1.459,1.459,0,0,0-1.455,1.455v1.7A2.64,2.64,0,0,1,20.765,31.4c-1.795,0-2.765-.97-2.765-2.91V12H28.671a2.919,2.919,0,0,1,2.91,2.91v7.506",
    transform: "translate(-2.418)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M35.971,40a1.459,1.459,0,0,1,1.455,1.455v1.892a2.728,2.728,0,0,1-2.91,2.474H23.7a2.513,2.513,0,0,0,2.571-2.28V41.455A1.459,1.459,0,0,1,27.726,40Z",
    transform: "translate(-5.354 -14.419)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1930",
    "data-name": "Rectangle 1930",
    width: 5,
    height: 5,
    transform: "translate(19.976 17.64)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M31.91,22.425H29v-.97A1.429,1.429,0,0,1,30.455,20h0a1.429,1.429,0,0,1,1.455,1.455Z",
    transform: "translate(-8.083 -5.12)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonDocIcon);
export default __webpack_public_path__ + "static/media/falkon-doc-icon.26df8f5fa073a0a19547f3c244a4286c.svg";
export { ForwardRef as ReactComponent };